import StewardAssetEditPage from './StewardAssetEditPage';

export default StewardAssetEditPage;
